import MDTypography from "@components/MDTypography";
import { Box, Skeleton } from "@mui/material";
import { ReactNode } from "react";

interface FieldCellProps {
    label: string;
    value?: string;
    isLoading: boolean;
    sx?: object;
    skeletonBg: string;
    children?: ReactNode;
    inline?: boolean;
}

export const FieldCell = ({ label, value, isLoading, sx, skeletonBg, children, inline }: FieldCellProps) =>
    isLoading ? (
        <Box sx={sx}>
            <Skeleton variant="text" width={60} height={14} sx={{ bgcolor: skeletonBg }} />
            <Skeleton variant="text" width={100} height={20} sx={{ bgcolor: skeletonBg }} />
        </Box>
    ) : (
        <Box sx={{ display: inline ? 'flex' : 'block', gap: inline ? 1 : 0, alignItems: inline ? 'center' : undefined, ...sx }}>
            <MDTypography variant="caption" color="secondary" fontWeight="medium" sx={{ lineHeight: 1.3, display: 'block', whiteSpace: inline ? 'nowrap' : undefined }}>
                {label}
            </MDTypography>
            {children ?? (
                <MDTypography variant="button" color="dark" fontWeight="regular" sx={{ lineHeight: 1.4, wordBreak: 'break-word' }}>
                    {value || '—'}
                </MDTypography>
            )}
        </Box>
    );